export const app = {
  namespaced: true,
  state: {
    name: "Online Sınav",
    version: "v1.0.0",
    home_work:  true,
  },
  getters: {
    getAppName (state) {
      return state.name;
    },
  },
  actions: {
  },
  mutations: {
  }
};